// @ts-nocheck
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getObjectFromSearchParams } from "../helpers/urlUtils";

export const UtmParamsContext = React.createContext({});

const UtmParamsContextProvider = ({ children }) => {
    const [utmParams, setUtmParams] = useState({});

    useEffect(() => {
        const params = getObjectFromSearchParams();

        /* eslint-disable camelcase */
        setUtmParams({
            ...(params.utm_source && { utm_source: params.utm_source }),
            ...(params.utm_medium && { utm_medium: params.utm_medium }),
            ...(params.utm_campaign && { utm_campaign: params.utm_campaign }),
            ...(params.utm_content && { utm_content: params.utm_content }),
        });
        /* eslint-enable */
    }, []);

    return <UtmParamsContext.Provider value={{ utmParams }}>{children}</UtmParamsContext.Provider>;
};

UtmParamsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default UtmParamsContextProvider;
